import { useState } from 'react';
import { BPointClientAPI, PaymentAddComponentProps } from '../../../contracts';
import { BPointSettings, useBPointClientScripts } from '../../shared';
import { DebitForm } from '../direct-debit';
declare global {
	interface Window {
		BPOINT: BPointClientAPI;
	}
}

export function BPointAddDirectDebit({ onSuccess, settings, completeIntent, intentData, onCancel, showSave }: PaymentAddComponentProps) {
	const [error, setError] = useState<string | undefined>(!intentData ? 'Failed to initialise connection to BPoint' : undefined);

	const ready = useBPointClientScripts(settings as BPointSettings);

	const submit = submitData =>
		new Promise((resolve, reject) => {
			window.BPOINT.token.authkey.attachPaymentMethod(
				intentData.key,
				{
					bank: {
						account: submitData.accountNumber,
						bsb: submitData.bsb,
						name: submitData.accountName
					}
				},
				async (status, data) => {
					console.log('setup complete', status, data);
					if (status === 'error') {
						setError('Failed to add payment method');
						reject('Failed to add payment method');
						return;
					}
					const result = await completeIntent(intentData.key, JSON.stringify(data.bank));

					if (!result) {
						setError('Failed to create the new payment method');
						reject('Failed to create the new payment method');
						return;
					}
					onSuccess(result);
					resolve(result);
				}
			);
		});

	return <DebitForm submitFunc={submit} onCancel={onCancel} showSave={showSave} />;
}
